import { call, put, takeLatest } from 'redux-saga/effects';
import { InsurancePolicyItemApi } from '@apis/InsurancePolicyItemApi';
import { InsurancePolicyItemList } from '@models/InsurancePolicyItem';
import { insurancePolicyItemsFetch, stateUpdate, StateUpdatePayload } from './action';

function* handleInsurancePolicyItemsFetch() {
  const state: StateUpdatePayload = { policyItems: null };
  try {
    state.policyItems = (yield call(InsurancePolicyItemApi.getAll)) as InsurancePolicyItemList[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyItemsFetch, handleInsurancePolicyItemsFetch);
}
